<div (click)="toggleContent()" class="accordion-header">
  <div>
    <ng-content></ng-content>
  </div>
  <i [ngClass]="{'icon-caret-down': !contentShown, 'icon-caret-up': contentShown}"></i>
</div>
